/**
 * Highlights the next upcoming holiday/early-close in the table
 * and shows a "next holiday" banner at the top.
 */
function highlightNextHoliday() {
  const rows = document.querySelectorAll<HTMLTableRowElement>('.holiday-table tbody tr[data-date]');
  const banner = document.getElementById('next-holiday');
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  for (const row of rows) {
    const dateStr = row.getAttribute('data-date');
    if (!dateStr) continue;

    const rowDate = new Date(dateStr + 'T00:00:00');
    if (rowDate >= today) {
      row.classList.add('holiday-next');

      if (banner) {
        const holidayName = row.cells[2]?.textContent || '';
        const holidayDate = row.cells[0]?.textContent || '';
        const isEarly = row.getAttribute('data-early') === 'true';

        if (rowDate.getTime() === today.getTime()) {
          banner.innerHTML = isEarly
            ? `⚠️ <strong>Today is an early close day</strong> (${holidayName}). Markets close at 1:00 PM ET.`
            : `🚫 <strong>Today the market is closed</strong> for ${holidayName}.`;
        } else {
          banner.innerHTML = `📅 <strong>Next market holiday:</strong> ${holidayName}, ${holidayDate}${isEarly ? ' (early close 1:00 PM ET)' : ' (closed)'}.`;
        }
      }
      return;
    }
  }
}

highlightNextHoliday();
